import React from 'react';

export const ArrowRightIcon = (props) => (
    <svg {...props} viewBox="0 0 13 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.24 18.76L11.3705 11.6295C11.8504 11.1496 12.12 10.4987 12.12 9.82C12.12 9.1413 11.8504 8.49039 11.3705 8.01047L4.24 0.880002C3.07 -0.289998 1.17 -0.289998 0 0.880002L8.94 9.82L0 18.76C1.17 19.93 3.07 19.93 4.24 18.76Z" />
    </svg>
);

export default ArrowRightIcon;
